import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  MenuItem,
  makeStyles,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactFlagsSelect from "react-flags-select";
import axios from "src/utils/axios";
import { getUser } from "src/utils/Common";
import { useTranslation } from "react-i18next";
import { getCountryByCode } from "src/utils/countryHelper";

const useStyles = makeStyles((theme) => ({
  field: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 14,
      paddingRight: "14px !important",
      backgroundColor: "#fff",
      transition: "all 0.2s ease-in-out",
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#4DA3FF",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderWidth: 2,
        borderColor: "#1B84FF",
        boxShadow: "0 0 6px rgba(27,132,255,0.3)",
      },
    },
    "& .MuiAutocomplete-inputRoot": {
      borderRadius: 14,
      padding: "0px !important",
      "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: 14,
      },
      "& input": {
        padding: "14px !important",
      },
    },
    "& .MuiInputBase-input": {
      paddingTop: 14,
      paddingBottom: 14,
    },
  },
  sectionLabel: {
    fontSize: 15,
    fontWeight: 700,
    color: "#1b84ff",
    margin: theme.spacing(1.5, 0, 1),
    display: "inline-block",
    position: "relative",
    "&::after": {
      content: '""',
      display: "block",
      width: 40,
      height: 3,
      background: "linear-gradient(90deg, #00B2FF, #0079FF)",
      borderRadius: 2,
      marginTop: 4,
    },
  },
  flagsRoot: {
    "& .ReactFlagsSelect-module_selectBtn__19wW7": {
      borderRadius: 14,
      height: 44,
      border: "1px solid #CED6E0",
      background: "#fff",
      fontSize: 14,
      padding: "0 12px",
      display: "flex",
      alignItems: "center",
      transition: "all 0.2s ease-in-out",
    },
    "& .ReactFlagsSelect-module_selectBtn__19wW7:hover": {
      borderColor: "#4DA3FF",
    },
    "& .ReactFlagsSelect-module_selectBtn__19wW7:focus": {
      borderColor: "#1B84FF",
      boxShadow: "0 0 6px rgba(27,132,255,0.3)",
    },
    "& .ReactFlagsSelect-module_selectValue__152eS": {
      lineHeight: "normal",
      padding: 0,
      margin: 0,
    },
  },
}));



export default function AddressBlock({
  value,
  onChange,
  maskedMode = false, 
  sessionTenantId = 0,
  errors = {},
}) {
  const classes = useStyles();
  const { t } = useTranslation("overview");
  const SessionUser = getUser();

  // AssignedJob SAFE equivalent
  const Safe = (v) => (v && v.trim() !== "" ? v : "0");

  const [formData, setFormData] = useState(
    value || {
      Country: "",
      AddressTypeId: 1,
      State: "",
      Region: "",
      City: "",
      District: "",
      Neighborhood: "",
      Street: "",
      Apartment: "",
      DoorNr: "",
      PostCode: "",
      AddressItem: "",
    }
  );

  const [RegionData, setRegionData] = useState([]);
  const [CityData, setCityData] = useState([]);
  const [DistrictData, setDistrictData] = useState([]);
  const [NeighborhoodData, setNeighborhoodData] = useState([]);
  const [PostCodeData, setPostCodeData] = useState([]);
  const [AddressTypes, setAddressTypes] = useState([]);

   const tenantCode = (SessionUser?.TenantCode || "").toString().toUpperCase();
  
  // LOAD IF value CHANGED
  useEffect(() => {
    if (value) setFormData(value);
  }, [value]);

  useEffect(() => {
    if (!formData.Country) {
      const tenantCode = SessionUser?.TenantCode?.toUpperCase();
      const country = getCountryByCode(tenantCode);

      if (country) {
        setFormData(prev => ({
          ...prev,
          Country: country.code
        }));
      }
    }
  }, []);


  const updateField = (key, val) => {
    setFormData((prev) => ({ ...prev, [key]: val }));
  };

  const safeValue = (val, list) => {
    if (!list || list.length === 0) return "";
    return list.includes(val) ? val : "";
  };

  // Mask helper
  const mask = (v) => {
    if (!v) return "";
    if (v.length <= 3) return v;
    return v.slice(0, 3) + "*".repeat(v.length - 3);
  };


  // PROPAGATE UP
  useEffect(() => {
    onChange && onChange(formData);
  }, [formData]);

  useEffect(() => {
  const canLoadPostCode =
    formData.Region &&
    formData.City &&
    
    (formData.District || formData.District === "") &&
    RegionData.length > 0 &&
    CityData.length > 0 &&
    (DistrictData.length > 0 || formData.District === "");

  if (!canLoadPostCode) return;
    GetPostCode(
      Safe(formData.Region),
      Safe(formData.City),
      Safe(formData.District)
    );

  }, [
    formData.Region,
    formData.City,
    formData.District,
    RegionData,
    CityData,
    DistrictData
  ]);

  // -----------------------
  // API CALLS
  // -----------------------

  const GetAddressTypes = async () => {
    try {
      const res = await axios.get("/GetAddressTypes");
      setAddressTypes(res.data);
    } catch {
      setAddressTypes([{ Id: 1, Dsc: "Default" }]);
    }
  };

  const GetRegionRequest = () => {
  axios.get('/GetRegionRequest/')
    .then(res => {
      setRegionData(res.data);

      if (res.data.length === 1) {
        GetCityRequest();
      }
    });
};

const GetCityRequest = () => {
  axios.get('/GetCityRequest/')
    .then(res => {
      setCityData(res.data);
    });
};

const GetCityRequestByRegion = (regionName) => {
  axios.get('/GetCityRequestByRegion/' + regionName)
    .then(res => {
      setCityData(res.data);
    });
};

  const GetDistrictData = async (cityName, regionName) => {
    try {
      const res = await axios.get(
        `/GetDistrictRequest/${Safe(cityName)}/${Safe(regionName)}`
      );
      setDistrictData(res.data);

      setFormData((p) => ({
        ...p,
        District: "",
        Neighborhood: "",
        PostCode: "",
      }));
    } catch {
      setDistrictData([]);
    }
  };

  const GetNeighborhood = async (cityName, districtName) => {
    try {
      const res = await axios.get(
        `/GetNeighborhoodsRequest/${Safe(cityName)}/${Safe(districtName)}`
      );
      setNeighborhoodData(res.data);
    } catch {
      setNeighborhoodData([]);
    }
  };

  const GetPostCode = async (regionName, cityName, districtName) => {
    const url = `/GetPostCodeRequest/${Safe(regionName)}/${Safe(cityName)}/${Safe(districtName)}`;

    try {
      const res = await axios.get(url);

      const list = (res.data || []).map((x) => String(x.PostCode));

      setPostCodeData(list);

      // Backend'ten gelen postcode varsa listede eşleşsin
      if (list.includes(formData.PostCode)) {
        updateField("PostCode", formData.PostCode);
      }
    } catch (err) {
      console.error("❌ GetPostCode ERROR:", err);
      setPostCodeData([]);
    }
  };

  const handleRegionChange = (event, newRegion) => {
    updateField("Region", newRegion || "");
    updateField("City", "");
    updateField("District", "");
    updateField("Neighborhood", "");
    updateField("PostCode", "");

    if (RegionData.includes(newRegion)) {
      // Bölgeye göre şehirleri getir
      GetCityRequestByRegion(newRegion);
    } else {
      // Ülkeye göre default şehir listesi getir
      GetCityRequest();
    }
  };

  const handleCityChange = (newCity) => {
    setFormData(prev => ({
      ...prev,
      City: newCity || "",
      District: "",
      Neighborhood: "",
      PostCode: ""
    }));

    if (CityData.includes(newCity)) {
      const region = formData.Region || "0";

      GetDistrictData(newCity, region);
      GetNeighborhood(newCity, "0");
      GetPostCode(region, newCity, "0");
    }
  };

  const handleDistrictChange = (newDistrict) => {
    setFormData(prev => ({
      ...prev,
      District: newDistrict || "",
      Neighborhood: "",
      PostCode: ""
    }));

    if (DistrictData.includes(newDistrict)) {
      const region = formData.Region || "0";
      const city = formData.City || "0";

      GetNeighborhood(city, newDistrict);
      GetPostCode(region, city, newDistrict);
    }
  };

  const handlePostCodeChange = (newPost) => {
    setFormData(prev => ({
      ...prev,
      PostCode: newPost || ""
    }));

  };


  // -----------------------
  // INITIAL LOAD
  // -----------------------
  useEffect(() => {
    GetAddressTypes();
    GetRegionRequest();
    GetCityRequest();

    if (formData.City) {
      const region = formData.Region || "0";
      const district = formData.District || "0";

      GetDistrictData(formData.City, region);
      GetNeighborhood(formData.City, district);
      GetPostCode(region, formData.City, district);
    }
  }, []);

 return (
  <Grid container spacing={2}>

    {/* COUNTRY */}
    <Grid item xs={12} sm={6}>
      <ReactFlagsSelect
        className={classes.flagsRoot}
        searchable
        disabled={maskedMode}
        selected={formData.Country}
        onSelect={(code) => {
          const country = getCountryByCode(code);
          setFormData(prev => ({
            ...prev,
            Country: country?.code || code
          }));
        }}
      />
    </Grid>

    {/* ADDRESS TYPE */}
    <Grid item xs={12} sm={6}>
      <TextField
        select
        fullWidth
        className={classes.field}
        variant="outlined"
        label={t("addressType")}
        disabled={maskedMode}
        value={Number(formData.AddressTypeId)}
        onChange={(e) => updateField("AddressTypeId", Number(e.target.value))}
      >
        {AddressTypes.map((p) => (
          <MenuItem key={p.Id} value={p.Id}>
            {p.Dsc}
          </MenuItem>
        ))}
      </TextField>
    </Grid>

    {/* STATE */}
    <Grid item xs={12} sm={6}>
      <TextField
        className={classes.field}
        fullWidth
        label={t("state")}
        variant="outlined"
        disabled={maskedMode}
        value={maskedMode ? mask(formData.State) : formData.State}
        onChange={(e) => updateField("State", e.target.value)}
      />
    </Grid>

    {/* REGION */}
    <Grid item xs={12} sm={6}>
      <Autocomplete
        className={classes.field}
        fullWidth
        options={RegionData}
        disabled={maskedMode}
        value={maskedMode ? mask(formData.Region) : safeValue(formData.Region, RegionData)}
        onChange={handleRegionChange}
         renderInput={(params) => (
    <TextField {...params} label={t("region")} variant="outlined" />
  )}
      />
    </Grid>

    {/* CITY */}
    <Grid item xs={12} sm={6}>
      <Autocomplete
        className={classes.field}
        fullWidth
        disabled={maskedMode}
        options={CityData}
        value={maskedMode ? mask(formData.City) : safeValue(formData.City, CityData)}
          onChange={(e, newValue) => handleCityChange(newValue)}
        renderInput={(params) => (
          <TextField {...params} label={t("city")} disabled={maskedMode} variant="outlined" error={!!errors.city} helperText={errors.city}/>
        )}
      />
    </Grid>

    {/* DISTRICT */}
    <Grid item xs={12} sm={6}>
      <Autocomplete
        className={classes.field}
        fullWidth
        disabled={maskedMode}
        options={DistrictData}
        value={maskedMode ? mask (formData.District) : safeValue(formData.District, DistrictData)}
        onChange={(e, newValue) => handleDistrictChange(newValue)}
        renderInput={(params) => (
          <TextField {...params} label={t("district")} variant="outlined" />
        )}
      />
    </Grid>

    {/* NEIGHBORHOOD */}
    <Grid item xs={12} sm={6}>
      <Autocomplete
        className={classes.field}
        fullWidth
        disabled={maskedMode}
        options={NeighborhoodData}
        value={maskedMode ? mask(formData.Neighborhood) : safeValue(formData.Neighborhood, NeighborhoodData)}
        onChange={(e, val) => updateField("Neighborhood", val || "")}
        renderInput={(params) => (
          <TextField {...params} label={t("neighborhood")} variant="outlined" />
        )}
      />
    </Grid>

    {/* STREET */}
    <Grid item xs={12} sm={6}>
      <TextField
        className={classes.field}
        fullWidth
        label={t("street")}
        variant="outlined"
        disabled={maskedMode}
        value={maskedMode ? mask(formData.Street) : formData.Street}
        onChange={(e) => updateField("Street", e.target.value)}
        error={!!errors.street}
        helperText={errors.street}
      />
    </Grid>

    {/* APARTMENT */}
    <Grid item xs={12} sm={4}>
      <TextField
        className={classes.field}
        fullWidth
        label={t("apartment")}
        variant="outlined"
        disabled={maskedMode}
        value={maskedMode ? mask(formData.Apartment) : formData.Apartment}
        onChange={(e) => updateField("Apartment", e.target.value)}
      />
    </Grid>

    {/* DOORNR */}
    <Grid item xs={12} sm={4}>
      <TextField
        className={classes.field}
        fullWidth
        label={t("doorNr")}
        variant="outlined"
        disabled={maskedMode}
        value={maskedMode ? mask(formData.DoorNr) : formData.DoorNr}
        onChange={(e) => updateField("DoorNr", e.target.value)}
      />
    </Grid>

    {/* POSTCODE */}
    <Grid item xs={12} sm={4}>
      <Autocomplete
        className={classes.field}
        fullWidth
        disabled={maskedMode}
        options={PostCodeData}
        freeSolo={PostCodeData.length === 0}
        value={
          PostCodeData.includes(formData.PostCode)
            ? formData.PostCode
            : ""
        }
        onChange={(e, newValue) => handlePostCodeChange(newValue)}
        onInputChange={(e, val) => {
          if (!maskedMode && PostCodeData.length === 0) updateField("PostCode", val);
        }}
        renderInput={(params) => (
          <TextField {...params} label={t("postCode")} variant="outlined" error={!!errors.postCode} helperText={errors.postCode}/>
        )}
      />
    </Grid>

    {/* ADDRESS FREE TEXT */}
    <Grid item xs={12}>
      <TextField
        className={classes.field}
        fullWidth
        multiline
        rows={3}
        label={t("address")}
        variant="outlined"
        disabled={maskedMode}
        value={maskedMode ? mask(formData.AddressItem) : formData.AddressItem}
        onChange={(e) => updateField("AddressItem", e.target.value)}
      />
    </Grid>

  </Grid>
);

}
